import { Menu, Typography } from "@mui/material";
import FilterMenuItem from "./FilterMenuItem";

const FilterSubmenu = ({
  anchorEl,
  open,
  onClose,
  title,
  items,
  selectedItems,
  onItemToggle,
  getIcon,
  getDisplayName,
  colors,
}) => (
  <Menu
    anchorEl={anchorEl}
    open={open}
    onClose={onClose}
    PaperProps={{
      style: {
        maxHeight: "200px",
        maxWidth: "250px",
        minWidth: "190px",
        borderRadius: "8px",
        padding: "4px",
        marginLeft: "4px",
        boxShadow: "0px 1px 4px 0px " + colors.grey_48percent,
      },
    }}
    anchorOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "left",
    }}
    MenuListProps={{
      disablePadding: true,
    }}
  >
    <Typography
      variant="overline"
      sx={{
        color: colors.text_secondary,
        padding: "8px 4px",
      }}
    >
      {title}
    </Typography>
    {items.map((item) => (
      <FilterMenuItem
        key={item}
        checked={selectedItems.includes(item)}
        onToggle={() => onItemToggle(item)}
        icon={getIcon ? getIcon(item) : null}
        colors={colors}
        text={getDisplayName ? getDisplayName(item) : item}
      />
    ))}
  </Menu>
);

export default FilterSubmenu;
